/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CrmProjectContactData
 */
export interface CrmProjectContactData {
    /**
     * 
     * @type {string}
     * @memberof CrmProjectContactData
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectContactData
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectContactData
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectContactData
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectContactData
     */
    roleName?: string | null;
    /**
     * 
     * @type {CrmProjectContactDataRoleKnowledgeEnum}
     * @memberof CrmProjectContactData
     */
    roleKnowledge?: CrmProjectContactDataRoleKnowledgeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CrmProjectContactData
     */
    isOwner?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CrmProjectContactData
     */
    isMember?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CrmProjectContactData
     */
    isAdministrator?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectContactData
     */
    userDeletedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectContactData
     */
    removedAt?: Date | null;
    /**
     * 
     * @type {CrmProjectContactDataContactOriginEnum}
     * @memberof CrmProjectContactData
     */
    contactOrigin?: CrmProjectContactDataContactOriginEnum;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectContactData
     */
    userCreatedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectContactData
     */
    lastActivityAt?: Date | null;
}


/**
 * @export
 */
export const CrmProjectContactDataRoleKnowledgeEnum = {
    Known: 'known',
    Unknown: 'unknown'
} as const;
export type CrmProjectContactDataRoleKnowledgeEnum = typeof CrmProjectContactDataRoleKnowledgeEnum[keyof typeof CrmProjectContactDataRoleKnowledgeEnum];

/**
 * @export
 */
export const CrmProjectContactDataContactOriginEnum = {
    Observed: 'observed',
    LegacyInferred: 'legacy_inferred'
} as const;
export type CrmProjectContactDataContactOriginEnum = typeof CrmProjectContactDataContactOriginEnum[keyof typeof CrmProjectContactDataContactOriginEnum];


/**
 * Check if a given object implements the CrmProjectContactData interface.
 */
export function instanceOfCrmProjectContactData(value: object): value is CrmProjectContactData {
    return true;
}

export function CrmProjectContactDataFromJSON(json: any): CrmProjectContactData {
    return CrmProjectContactDataFromJSONTyped(json, false);
}

export function CrmProjectContactDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmProjectContactData {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] === undefined ? undefined : json['userId'] === null ? null : json['userId'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'phone': json['phone'] === undefined ? undefined : json['phone'] === null ? null : json['phone'],
        'roleName': json['roleName'] === undefined ? undefined : json['roleName'] === null ? null : json['roleName'],
        'roleKnowledge': json['roleKnowledge'] == null ? undefined : json['roleKnowledge'],
        'isOwner': json['isOwner'] == null ? undefined : json['isOwner'],
        'isMember': json['isMember'] == null ? undefined : json['isMember'],
        'isAdministrator': json['isAdministrator'] == null ? undefined : json['isAdministrator'],
        'userDeletedAt': json['userDeletedAt'] === undefined ? undefined : json['userDeletedAt'] === null ? null : (new Date(json['userDeletedAt'])),
        'removedAt': json['removedAt'] === undefined ? undefined : json['removedAt'] === null ? null : (new Date(json['removedAt'])),
        'contactOrigin': json['contactOrigin'] == null ? undefined : json['contactOrigin'],
        'userCreatedAt': json['userCreatedAt'] === undefined ? undefined : json['userCreatedAt'] === null ? null : (new Date(json['userCreatedAt'])),
        'lastActivityAt': json['lastActivityAt'] === undefined ? undefined : json['lastActivityAt'] === null ? null : (new Date(json['lastActivityAt'])),
    };
}

export function CrmProjectContactDataToJSON(json: any): CrmProjectContactData {
    return CrmProjectContactDataToJSONTyped(json, false);
}

export function CrmProjectContactDataToJSONTyped(value?: CrmProjectContactData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'name': value['name'],
        'email': value['email'],
        'phone': value['phone'],
        'roleName': value['roleName'],
        'roleKnowledge': value['roleKnowledge'],
        'isOwner': value['isOwner'],
        'isMember': value['isMember'],
        'isAdministrator': value['isAdministrator'],
        'userDeletedAt': value['userDeletedAt'] == null ? value['userDeletedAt'] : value['userDeletedAt'].toISOString(),
        'removedAt': value['removedAt'] == null ? value['removedAt'] : value['removedAt'].toISOString(),
        'contactOrigin': value['contactOrigin'],
        'userCreatedAt': value['userCreatedAt'] == null ? value['userCreatedAt'] : value['userCreatedAt'].toISOString(),
        'lastActivityAt': value['lastActivityAt'] == null ? value['lastActivityAt'] : value['lastActivityAt'].toISOString(),
    };
}

